import "./detail.css"
import CurrencyFormat from "react-currency-format"
import { useGlobalContext } from "../../context"
import { FaX } from "react-icons/fa6"

function Detailpro() {
    const {
        setSize,
        size,
        product,
        handleQuentity,
        handleAddProductToCart,
        showdetail,
        setShowdetail,
        setQtyInStore,
    } = useGlobalContext()
    return (
        <div className={showdetail ? "detail-pro show" : "detail-pro"}>
            <div className="detail-product">
                <div className="detail-container">
                    <div className="detail-img">
                        <span className="close-show-detail" onClick={() => {
                            setShowdetail(false)
                            setSize("")
                            setQtyInStore("")
                        }} style={{ cursor: "pointer" }}>
                            <FaX size={25} />
                        </span>
                        <img src={product.img && product.img[0]} alt="" />
                    </div>
                    <ul>
                        <li>
                            <span style={{ fontSize: "30px" , color : "white"}}>{product.name}</span>
                        </li>
                        <li>
                            <span style={{ fontSize: "13px", color: "white" }}>{product.code}</span>
                        </li>
                        <li>
                            <span style={{ fontSize: "30px", color: "orange" }}>
                                <CurrencyFormat thousandSeparator={true}
                                    value={product.price}
                                    prefix="تومان"
                                    displayType="text">
                                </CurrencyFormat>
                            </span>
                        </li>
                        <li className="existed-size">
                            <span style={{color : "white"}}>سایز : </span>
                            {
                                product.size &&
                                product.size.map((elem, i) => {
                                    return (
                                        <div className={product.store[i] == 0 ? "detail-size none" : "detail-size"} onClick={() => {
                                            setSize(elem)
                                            setQtyInStore(product.store[i])
                                            product.qty = 1
                                        }} key={i}>
                                            <button className={size == elem ? "selected-size selected" : "selected-size"}>
                                                <span>
                                                    {elem}
                                                </span>
                                            </button>
                                        </div>
                                    )
                                })
                            }
                        </li>
                        <li className="qty">
                            <span style={{color : "white"}}>تعداد : </span>
                            <div>
                                <button style={{boxShadow : "0 0 0 0"}} className={size ? "incbtn" : "incbtn nonebtn"} onClick={() => handleQuentity("I")}>+</button>
                                <span style={{color : "white"}}>{product.qty}</span>
                                <button style={{boxShadow : "0 0 0 0"  , border : "none"}} onClick={() => handleQuentity("D")}>-</button>
                            </div>
                        </li>
                        <li className="subtocart">
                            <button style={{boxShadow : "0 0 0 0"}} onClick={() => handleAddProductToCart()}>افزودن به سبد</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Detailpro;